import { applyMiddleware, configureStore } from '@reduxjs/toolkit';
import { routerMiddleware } from 'connected-react-router';
import { rootReducer } from './rootReducer';
import { history } from './rootReducer';
import { baseApi } from '../services/api/apiProvider';

export type AppState = ReturnType<typeof rootReducer>;

export const store = configureStore({
  reducer: rootReducer,
  enhancers: [applyMiddleware(routerMiddleware(history))],
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(baseApi.middleware),
});
